import React, { useState } from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

interface NotesTranscriptSwitchProps {
  notesLabel: string;
  notes: React.ReactNode;
  /** Null when there is no video to transcribe: the notes show alone. */
  transcript: React.ReactNode | null;
  testId?: string;
}

/**
 * Beside the player: the notes, or the transcript. The transcript stays
 * mounted once opened, so one being made keeps moving while the notes show.
 */
const NotesTranscriptSwitch: React.FC<NotesTranscriptSwitchProps> = ({ notesLabel, notes, transcript, testId = 'notes-transcript-switch' }) => {
  const [view, setView] = useState<'notes' | 'transcript'>('notes');
  const [opened, setOpened] = useState(false);
  if (!transcript) return <>{notes}</>;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, minWidth: 0 }} data-testid={testId}>
      <ToggleButtonGroup
        exclusive
        size="small"
        fullWidth
        value={view}
        onChange={(_, value) => {
          if (!value) return;
          setView(value);
          if (value === 'transcript') setOpened(true);
        }}
        aria-label="Beside the player"
      >
        <ToggleButton value="notes" sx={{ textTransform: 'none', fontWeight: 600 }}>
          {notesLabel}
        </ToggleButton>
        <ToggleButton value="transcript" sx={{ textTransform: 'none', fontWeight: 600 }}>
          Transcript
        </ToggleButton>
      </ToggleButtonGroup>
      <Box sx={{ display: view === 'notes' ? 'block' : 'none' }}>{notes}</Box>
      {opened && <Box sx={{ display: view === 'transcript' ? 'block' : 'none' }}>{transcript}</Box>}
    </Box>
  );
};

export default NotesTranscriptSwitch;
